<style lang='stylus'scoped>


header {
  margin-top: 10px;
}

.title {
  font-size: 18px;
  color: #999999;
  position: relative;

  &:first-child {
    margin-right: 40px;
  }

  &::after {
    content: '';
    display: block;
    height: 3px;
    position: absolute;
    bottom: -12px;
    left: 15%;
    width: 70%;
  }
}

.title.active {
  color: '#336db0';

  &::after {
    background: @color;
  }
}

.demonstration {
  color: #999;
  font-size: 18px;
  margin-right: 15px;
}

.header {
  display: flex;
  justify-content: space-between;
}

.km {
  color: #999;
  width: 100%;
  text-align: right;
  padding-top: 25px;
  font-size: 14px;
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.carWrap {
  padding: 20px;
  background: #fff;
  border-radius: 10px;

  main {
    flex: 1;
  }
}

.block {
  display: flex;

  .center {
    margin: 10px auto;
  }
}
</style>

<template>
  <div>
    <div class="carWrap">
      <exportDate v-if="showExport" @hideExport="hideExport1" :moduleName="moduleName"/>
      <div class="header">
        <TitleHeader :titleArr="titleArr" :changeTab="changeTab" :tab="tab"/>
        <!-- <TimeHeader :changeTime="changeTime" monTime="monTime"/> -->
        <div class="righth">
          <span class="demonstration">统计月份</span>
          <el-date-picker v-model="monTime" type="month" placeholder="选择月" @change="changeTime"></el-date-picker>
          <el-button v-show="hideExport" style="margin-left:15px;" @click="exportDate">导出</el-button>
          <div class="km">单位：辆</div>
        </div>
      </div>
      <main>
        <StopTable :allData="allData"></StopTable>
        <!-- <TimeTable :allData="allData" v-else></TimeTable> -->
      </main>
    </div>
    <div class="bottom-top">
      <h4>
        <img src="../../../assets/images/title.png">
        <span>说明</span>
      </h4>
      <div>1、全国车辆在本省的停靠车辆数；</div>
      <div>2、停靠占比划分：停靠某地区中石化的次数÷停靠该地区所有油站次数=xx%；</div>
      <div>3、其他占比区间、其他品牌分类同此规则。</div>
    </div>
  </div>
</template>
<script>
import StopTable from './components/stopTable' // 高速加油站停靠表格
// import TimeTable from './components/timeTable' // 高速运营时段表格
import TitleHeader from './components/titleHeader' // title表格
import TimeHeader from './components/timeHeader' // 时间选择控件
import Cookies from 'js-cookie'
import http from '@/api/freight.js' //请求汇总
import { hideExport } from '@/utils/tools'
import { 
    getBaseGasStationArray, 
  	getGasStationLabelByBrand } from '@/utils/dictionary'
var now = new Date()
now.setMonth(now.getMonth() - 1)
export default {
  components: {
    StopTable,
    // TimeTable,
    TitleHeader,
    TimeHeader
  },
  data() {
    let titleArr = getBaseGasStationArray();
    let poiType = getGasStationLabelByBrand(titleArr[0]);
    return {
      hideExport:hideExport,
      moduleName: 'vehiclePoiStopRadio',
      showExport: false, //控制批量导出
      //titleArr: ['中国石化', '中国石油', '其他油站'],
      titleArr,
      tab: 0, // 0 ->高速加油站 1 ->高速运营时段
      monTime: now,
      allData: [], // 总数据
      endMonth: '', //请求日期
      year: '',
      firstRequest:0,
      Month: '2',
      //poiType: '中国石化',
      poiType,
    }
  },
  mounted() {
    let that = this
    let time = that.monTime
    let year = time.getFullYear()
    let month = time.getMonth()
    that.endMonth = year + that.initMonth(month)
    this.year = year
    this.Month = that.initMonth(month)
    this.initData()
  },
  methods: {
    // 取消导出
    hideExport1() {
      this.showExport = false
    },
    initData() {
      let that = this
      that.allData = []
      http
        .carGasStation({
          year: that.year,
          Month: that.Month,
          poiType: this.poiType,
          firstRequest:this.firstRequest
        })
        .then(e => {
          if (e.data) {
        	  if(e.data.year&&e.data.month){
              that.monTime=e.data.year+"-"+e.data.month;
              that.year=e.data.year
              that.Month=e.data.month
            }
            if(e.code==200){
              let data = e.data.resultList
              let totalMap = e.data.totalMap
              data.splice(0, 0, totalMap)
              that.allData = [...data]
              if(this.firstRequest==0){
                that.monTime=e.data.year+"-"+e.data.month
                that.endMonth=e.data.year+e.data.month
                that.Month=e.data.month
                that.year=e.data.year
              }
            }
          }
        })
    },
    changeTab(index, item) {
      /*if (item === '其他油站') {
        this.poiType = '其他'
      } else {
        this.poiType = item
      }*/
      let tmp = getGasStationLabelByBrand(item);
      this.poiType = (tmp === '其他油站')? '其他':tmp;
      let that = this
      that.tab = index
      that.firstRequest=1
      that.initData()
    },
    initMonth(num) {
      let newNum = num + 1
      return newNum < 10 ? '0' + newNum : newNum + ''
    },
    changeTime() {
      let that = this
      let time = that.monTime
      let year = time.getFullYear()
      let month = time.getMonth()
      this.year = year
      this.Month = that.initMonth(month)
      that.endMonth = year + that.initMonth(month)
      that.firstRequest=1
      that.initData()
    },
    exportDate() {
      this.showExport = true
    }
  }
}
</script>